export class AppointmentCaseQueryParameters {
  addedByPowerlane?: string;
  appointmentId?: string;
  campaignNumber?: string;
  embed?: any;
  employeeId?: string;
  opCode?: string;
  page?: number;
  pageSize?: number;
  partKitsMaintenanceId?: string;
  sequence?: string;
  serviceGroupId?: string;
  technicianGroupId?: string;
  technicianId?: string;
  warrantySubmissionTypeId?: string;

  constructor(obj?: AppointmentCaseQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
